//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BodyText } from '@components/atoms/text/Text';
import { Modal } from '@components/molecules/modal/Modal';
import { rightsSkippedModalActions } from '@galleries/actions/rightsSkippedModalActions';

interface Props {
  onConfirm: () => void;
}

export const RightsSkippedModal = ({ onConfirm }: Props) => {
  const dispatch = useDispatch();

  const { isOpen } = useSelector((state) => state.galleries.rightsSkippedModal);

  const closeModal = () => {
    dispatch(rightsSkippedModalActions.closeRightsSkippedModal());
  };

  const confirmAndCloseModal = () => {
    onConfirm();
    closeModal();
  };

  return (
    <Modal
      closeModal={confirmAndCloseModal}
      contents={
        <BodyText>
          You have chosen to request rights later. Are you sure? You'll need to
          request rights before these items can be published to your Gallery.
        </BodyText>
      }
      isModalOpen={isOpen}
      primaryButtonInfo={{
        onClick: confirmAndCloseModal,
        buttonContent: (
          <span data-testid='rights-skipped-modal-skip-rights-button'>
            Request Rights Later
          </span>
        ),
      }}
      secondaryButtonInfo={{
        onClick: () =>
          dispatch(rightsSkippedModalActions.closeRightsSkippedModal()),
        buttonContent: 'Cancel',
      }}
      title='You have chosen to skip requesting rights.'
      width='wide'
    />
  );
};
